import useClickTracker from '@cohort/wallet/hooks/clickTracker';
import type {TrackingConfig} from '@cohort/wallet/lib/Tracking';
import {Link} from 'react-router-dom';

type TrackableInternalLinkProps = Parameters<typeof Link>[0] & {
  tracking: TrackingConfig;
};

const TrackableInternalLink: React.FC<TrackableInternalLinkProps> = props => {
  const {tracking, ...rest} = props;
  const trackingCallback = useClickTracker(tracking.namespace, tracking.metadata);

  return (
    <Link
      {...rest}
      onClick={e => {
        trackingCallback();
        props.onClick?.(e);
      }}
    />
  );
};

export default TrackableInternalLink;
